import { sendPost } from "@/api/base";
import { getAPIData } from "../helpers";
import { UploadEndRequest, UploadStartRequest } from "./types";

export const directUploadStart = (params: UploadStartRequest) =>
  getAPIData(sendPost("file/upload/direct/start/", params));

export const directUploadEnd = (params: UploadEndRequest) =>
  getAPIData(sendPost("file/upload/direct/finish/", params));
